import React from "react";
import EstimateWizardContainer from "./EstimateWizardContainer.tsx";
import EstimateFormMun from "../../contracts/estimates/EstimateFormMun.tsx";
import { COMPANY_IN_CHARGE_TYPE, REMARK_MUN, EstimateDto } from "../../contracts/estimates/types.ts";
import { useEstimateApi } from "../../hooks/useEstimateApi.ts";

export default function EstimateWizardMun() {
    const { previewContentPdfMun } = useEstimateApi();

    return (
        <EstimateWizardContainer
            companyInChargeIndex={1}
            defaultValues={{
                content: {
                    remark: REMARK_MUN
                } as any,
                companyInCharge: COMPANY_IN_CHARGE_TYPE[1]
            }}
            stepsConfig={[
                {
                    label: "견적서 본문",
                    render: (props) => <EstimateFormMun {...props} />
                }
            ]}
            getPreviewBlob={async (data: EstimateDto, activeStep: number) => {
                const content = await previewContentPdfMun(data);
                return { content };
            }}
        />
    );
}
